export default function OrderedList({ children }) {
  return (
    <ol className="list-outside list-decimal leading-relaxed p-0 pl-12 my-3 md:my-6 lg:my-8">
      {children}
    </ol>
  );
}
